/** Design System — border-width tokens (px). No hardcoded border px allowed. */
export const borderWidth = {
  none: 0,
  thin: 1,
  medium: 2,
  thick: 3,
  heavy: 4,
} as const;

export type BorderWidth = typeof borderWidth;
